import { WithHtmlSavvyTitle } from '@/with-html-savvy-title';
import { MainRequestProjectForm } from './form/main-request-project-form';
import { useAccountSwitchNotificationFromUrl } from '@/features/account/hooks/use-account-switch-notification-from-url';

export const RequestProjectPage = () => {
  useAccountSwitchNotificationFromUrl();

  return (
    <WithHtmlSavvyTitle title="Request a Solution">
      <MainRequestProjectForm />
    </WithHtmlSavvyTitle>
  );
};
